var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.334 13.2726C20.0581 13.7783 19.6425 14.1939 19.1368 14.4698L8.43735 20.3059C6.98281 21.0992 5.1605 20.5633 4.36711 19.1087C3.9799 18.3988 3.89566 17.5627 4.13348 16.7899L5.65781 11.8361L4.13348 6.88232C3.64619 5.29874 4.53491 3.61997 6.11849 3.13268C6.89134 2.89487 7.72747 2.97911 8.43735 3.36632L19.1368 9.2024C20.5914 9.99579 21.1274 11.8181 20.334 13.2726ZM18.5782 12.3149C18.8238 11.8647 18.6872 11.3088 18.2783 11.0199L18.1791 10.9582L7.47965 5.12211C7.24302 4.99304 6.96431 4.96496 6.70669 5.04423C6.21654 5.19506 5.9261 5.68833 6.01715 6.18067L6.04502 6.29411L7.49405 11.0031H12.75C13.3023 11.0031 13.75 11.4508 13.75 12.0031C13.75 12.516 13.364 12.9386 12.8666 12.9964L12.75 13.0031H7.39125L6.04502 17.3781C5.96575 17.6357 5.99383 17.9144 6.1229 18.151C6.36847 18.6012 6.90977 18.7874 7.37405 18.6L7.47965 18.5501L18.1791 12.714C18.3477 12.622 18.4862 12.4835 18.5782 12.3149Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.bf96fcbd.svg";
export { ForwardRef as ReactComponent };